export default __webpack_public_path__ + "static/media/Leigh_Ann_DeLyser.e44ac705.jpg";